export default "__VITE_ASSET__Cx9egVqU__"